module.exports = __webpack_public_path__ + "img/Team.dd589758.svg";